import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { Flame, Star, Calendar, Check } from 'lucide-react';

const DailyWidget = () => {
  const { userData, setUserData, getTodayLog } = useApp();
  const todayDone = !!getTodayLog();
  const today = new Date().toLocaleDateString('he-IL', { weekday: 'long' });
  const [nameDraft, setNameDraft] = useState('');

  const saveName = () => {
    const trimmed = nameDraft.trim();
    if (!trimmed) return;
    setUserData(prev => ({ ...prev, name: trimmed }));
  };

  return (
    <div className="bg-gradient-to-r from-brand-500 to-gold-500 rounded-2xl p-4 text-white shadow-lg">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1 min-w-0">
          <p className="text-brand-100 text-xs">{today}</p>
          {userData.name ? (
            <h2 className="text-xl font-bold mt-1">היי, {userData.name} 👋</h2>
          ) : (
            <div className="mt-1 flex items-center gap-2">
              <input
                type="text"
                value={nameDraft}
                onChange={e => setNameDraft(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && saveName()}
                placeholder="איך קוראים לך?"
                className="bg-white bg-opacity-20 placeholder-white rounded-lg px-2 py-1.5 text-sm font-semibold text-white focus:outline-none focus:bg-opacity-30 w-28"
              />
              <button
                onClick={saveName}
                disabled={!nameDraft.trim()}
                className="bg-white text-brand-600 rounded-lg p-1.5 disabled:opacity-40 shrink-0"
              >
                <Check className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-bold shrink-0 ${
          todayDone ? 'bg-brand-400 text-white' : 'bg-gold-300 text-stone-800'
        }`}>
          {todayDone ? '✅ בוצע' : '⏳ ממתין'}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <div className="bg-white bg-opacity-20 rounded-xl p-3 text-center">
          <Flame className="w-5 h-5 mx-auto mb-1 text-gold-200" />
          <p className="text-2xl font-bold">{userData.streak}</p>
          <p className="text-xs text-brand-100">רצף</p>
        </div>
        <div className="bg-white bg-opacity-20 rounded-xl p-3 text-center">
          <Calendar className="w-5 h-5 mx-auto mb-1 text-brand-100" />
          <p className="text-2xl font-bold">{userData.totalDays}</p>
          <p className="text-xs text-brand-100">ימים</p>
        </div>
        <div className="bg-white bg-opacity-20 rounded-xl p-3 text-center">
          <Star className="w-5 h-5 mx-auto mb-1 text-gold-200" />
          <p className="text-2xl font-bold">{userData.bestStreak}</p>
          <p className="text-xs text-brand-100">שיא</p>
        </div>
      </div>
    </div>
  );
};

export default DailyWidget;
